<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        class="filter-item"
        v-model="listQuery.hotel_code"
        placeholder="酒店编码"
        style="width: 220px"
        clearable
        size="small"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.hotel_name"
        placeholder="酒店名称"
        style="width: 220px"
        clearable
        size="small"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.city_code"
        placeholder="城市编码"
        style="width: 220px"
        clearable
        size="small"
      />
      <el-select
        class="filter-item"
        v-model="listQuery.is_up"
        placeholder="上架状态"
        style="width: 160px"
        clearable
        size="small"
      >
        <el-option label="未上架" :value="0" />
        <el-option label="已上架" :value="1" />
      </el-select>

      <el-button
        class="filter-item"
        type="primary"
        @click="handleFilter"
        size="small"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column label="丽呈酒店ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="酒店名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_name }}
        </template>
      </el-table-column>

      <el-table-column label="城市名称" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.city_name }}
        </template>
      </el-table-column>

      <el-table-column label="酒店地址" min-width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_address }}
        </template>
      </el-table-column>

      <el-table-column label="酒店电话" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.telephone }}
        </template>
      </el-table-column>

      <el-table-column label="上架状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_up === 0" type="danger">未上架</el-tag>
          <el-tag v-else-if="scope.row.is_up === 1" type="success"
            >已上架</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column
        v-if="$canEdit"
        label="操作"
        width="250"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              type="warning"
              size="mini"
              @click="syncHotelInfo(scope.row)"
              >同步酒店信息</el-button
            >
            <el-button
              type="warning"
              size="mini"
              @click="syncHotelRoomType(scope.row)"
              >同步房型</el-button
            >
          </div>
          <div style="margin-top: 5px">
            <el-button
              type="warning"
              size="mini"
              @click="syncHotelRoomStatus(scope.row)"
              :disabled="
                scope.row.book_flag != 1 ||
                scope.row.status != 1 ||
                scope.row.valid != 1
              "
              >同步房态</el-button
            >
            <el-button
              type="warning"
              size="mini"
              @click="up(scope.row)"
              :disabled="scope.row.is_up === 1"
              >上架酒店</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        hotel_code: '',
        hotel_name: '',
        city_code: '',
        is_up: null,
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/liCheng/hotel/hotelList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.items
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    syncHotelInfo(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/liCheng/hotel/syncHotelInfo',
            method: 'post',
            data: {
              inn_id: row.inn_id,
            },
            timeout: 10 * 60 * 1000,
          }).then(() => {
            this.list.length <= 1 && this.listQuery.page > 1
              ? this.listQuery.page--
              : false
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    syncHotelRoomType(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/liCheng/hotel/syncHotelRoomType',
            method: 'post',
            data: {
              inn_id: row.inn_id,
            },
            timeout: 10 * 60 * 1000,
          }).then(() => {
            this.list.length <= 1 && this.listQuery.page > 1
              ? this.listQuery.page--
              : false
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    syncHotelRoomStatus(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/liCheng/hotel/syncHotelRoomStatus',
            method: 'post',
            data: {
              inn_id: row.inn_id,
            },
            timeout: 10 * 60 * 1000,
          }).then(() => {
            this.list.length <= 1 && this.listQuery.page > 1
              ? this.listQuery.page--
              : false
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    syncHotelImage(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/liCheng/hotel/syncHotelImage',
            method: 'post',
            data: {
              inn_id: row.inn_id,
            },
            timeout: 10 * 60 * 1000,
          }).then(() => {
            this.list.length <= 1 && this.listQuery.page > 1
              ? this.listQuery.page--
              : false
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    up(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/liCheng/hotel/up',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
